"use client";

import { useState, type ReactNode } from "react";
import Image from "next/image";

/** An image that steps aside for an explicit fallback when it is missing or
 *  its host is down — never a stock artwork in its place, which a reader could
 *  not tell apart from the collection's own. */
export default function DeckImage({ src, alt, sizes, priority = false, fallback }: {
  src: string | null; alt: string; sizes: string; priority?: boolean; fallback: ReactNode;
}) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return <>{fallback}</>;
  return (
    <Image
      src={src}
      alt={alt}
      fill
      preload={priority} fetchPriority={priority ? "high" : undefined}
      loading={priority ? "eager" : "lazy"}
      sizes={sizes}
      style={{ objectFit: "cover" }}
      onError={() => setFailed(true)}
    />
  );
}
